import { render, staticRenderFns } from "./myUpload.vue?vue&type=template&id=040d2d8f&"
import script from "./myUpload.vue?vue&type=script&lang=js&"
export * from "./myUpload.vue?vue&type=script&lang=js&"
import style0 from "./myUpload.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports